import { Controller } from "@hotwired/stimulus"
import { patch } from "@rails/request.js"
import { showAlertModal } from "../lib/custom_confirm"

// Gear menu for the User Analytics dashboard (the shared menu, gl_more_menu):
// each widget is a multi-check row, so a pick fires more-menu:select with the
// row's new state and the menu stays open. A row PATCHes the hidden-widget
// list (every unchecked row); Reset clears both order and hidden. The page
// reloads on success so the server re-renders with the right widgets
// (visibility also controls which queries run server-side); a failed save
// puts the row's check back.
// Connects to data-controller="analytics-widgets"
export default class extends Controller {
  static values = { url: String }

  async select({ detail: { value, item, revert } }) {
    if (value === "reset") {
      await this.save({ order: [], hidden: [] })
      return
    }
    if (item.getAttribute("role") !== "menuitemcheckbox") return

    // The open list sits in the menu's layer, outside this element: read the rows from the item's own menu.
    const hidden = Array.from(item.closest('[role="menu"]').querySelectorAll('[role="menuitemcheckbox"]'))
      .filter((row) => row.getAttribute("aria-checked") !== "true")
      .map((row) => row.dataset.moreMenuValue)
    const saved = await this.save({ hidden })
    if (!saved) revert()
  }

  async save(body) {
    try {
      const response = await patch(this.urlValue, {
        body: JSON.stringify(body),
        contentType: "application/json",
        responseKind: "json"
      })
      if (response.ok) {
        this.reloadPage()
        return true
      }
    } catch {
      // Network failure (offline, timeout) — same user feedback as a 4xx/5xx.
    }
    await showAlertModal("Failed to save widget settings", { variant: "danger" })
    return false
  }

  // Wrapper so tests can stub navigation (jsdom forbids redefining
  // window.location).
  reloadPage() {
    window.location.reload()
  }
}
